import Cookies from 'cookie-universal'
import { META_LAST_PRODUCT_ID_COOKIE } from '@mc/constants'

export const setMetaProductIdCookie = (productId: string) => {
  const expires = new Date()
  expires.setDate(expires.getDate() + 30)
  const cookies = Cookies()
  cookies.set(META_LAST_PRODUCT_ID_COOKIE, productId, { path: '/', expires })
}
